// Attempt to match a frame in the error's stacktrace:
export const anyErrorFrameMatches = (error, fn) =>
  !!error.stacktrace?.frames?.some?.(fn);
